globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateRegistrar = (function(superClass)
{
    utils.extend(ModalCreateRegistrar, superClass);

    function ModalCreateRegistrar($html) {
      return ModalCreateRegistrar.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCreateRegistrar.prototype, {
      callbackSuccess: function(data) {
        if(data.response) {
          $('.registrars-select').each(function() {
            var $this = $(this);

            var option = new Option(data.name, data.id, true, true);

            $this.append(option).trigger('change');
          });

          ModalCreateRegistrar.__super__.callbackSuccess.apply(this, arguments);
        } else {
          ModalCreateRegistrar.__super__.callbackError.apply(this, arguments);
        }
      }
    });

    return ModalCreateRegistrar;
})(backoffice.ModalMain);
